/* PC STATION LB — Custom Collection Sort V5. Native Shopify select remains in form. */
(() => {
  const root = document.querySelector('#MainContent[data-template="collection"], #MainContent[data-template="search"]');
  if (!root || window.__pcslbCollectionSortV5) return;
  window.__pcslbCollectionSortV5 = true;
  let count = 0;
  const sel = 'facet-filters-form .facet-filters__field select.facet-filters__sort';

  function close(panel) {
    if (!panel) return;
    panel.dataset.open = 'false';
    const trigger = panel.querySelector('.pcslb-sort__trigger');
    const menu = panel.querySelector('.pcslb-sort__menu');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  }
  function closeAll(except) {
    root.querySelectorAll('.pcslb-sort[data-open="true"]').forEach(panel => {
      if (panel !== except) close(panel);
    });
  }
  function enhance(select) {
    if (select.dataset.pcslbSortV5) return;
    const original = select.closest('.select');
    const field = select.closest('.facet-filters__field');
    if (!original || !field || !select.form || !select.options.length) return;
    select.dataset.pcslbSortV5 = '1';
    const panel = document.createElement('div');
    panel.className = 'pcslb-sort';
    panel.dataset.open = 'false';
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pcslb-sort__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    const current = document.createElement('span');
    current.className = 'pcslb-sort__current';
    const arrow = document.createElement('span');
    arrow.className = 'pcslb-sort__chevron';
    arrow.setAttribute('aria-hidden', 'true');
    trigger.append(current, arrow);
    const menu = document.createElement('div');
    menu.className = 'pcslb-sort__menu';
    menu.id = 'pcslb-sort-v5-' + (++count);
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', 'Sort products');
    menu.hidden = true;
    trigger.setAttribute('aria-controls', menu.id);
    panel.append(trigger, menu);
    const options = [];

    function sync() {
      const selected = select.selectedOptions[0] || select.options[0];
      current.textContent = selected.textContent.trim();
      trigger.setAttribute('aria-label', 'Sort by ' + current.textContent);
      options.forEach(item => {
        item.button.setAttribute('aria-selected', String(item.source.value === select.value));
      });
    }
    for (const source of select.options) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pcslb-sort__option';
      button.setAttribute('role', 'option');
      button.textContent = source.textContent.trim();
      button.addEventListener('click', () => {
        const changed = select.value !== source.value;
        select.value = source.value;
        sync(); close(panel); trigger.focus();
        if (changed) select.dispatchEvent(new Event('input', { bubbles: true }));
      });
      options.push({ source, button });
      menu.appendChild(button);
    }
    function open(focusIndex) {
      closeAll(panel);
      panel.dataset.open = 'true';
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      sync();
      if (focusIndex !== undefined) options[Math.max(0, Math.min(options.length - 1, focusIndex))].button.focus();
    }
    trigger.addEventListener('click', () => {
      if (panel.dataset.open === 'true') close(panel); else open();
    });
    trigger.addEventListener('keydown', event => {
      if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
        event.preventDefault();
        const index = event.key === 'Home' ? 0 :
          event.key === 'End' ? options.length - 1 :
          Math.max(0, options.findIndex(item => item.source.value === select.value));
        open(index);
      } else if (event.key === 'Escape') close(panel);
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault(); close(panel); trigger.focus();
      } else if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
        event.preventDefault();
        const index = options.findIndex(item => item.button === document.activeElement);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 :
          Math.max(0, Math.min(options.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)));
        options[next].button.focus();
      }
    });
    panel.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!panel.contains(document.activeElement)) close(panel);
      }, 0);
    });
    const label = field.querySelector('label[for="' + select.id + '"]');
    if (label) label.addEventListener('click', event => {
      event.preventDefault(); trigger.click();
    });
    original.insertAdjacentElement('afterend', panel);
    original.classList.add('pcslb-sort-native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.addEventListener('change', sync);
    sync();
  }
  function scan() { root.querySelectorAll(sel).forEach(enhance); }
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.pcslb-sort')) closeAll();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeAll();
  });
  scan();
  new MutationObserver(scan).observe(root, { childList: true, subtree: true });
})();
